import type { TranslationKey } from "../locales";
import type { Enums, Nullable } from "../types";

export function getAttendanceSourceTranslationKey(
	source: Nullable<Enums<"attendanceSource">>,
): TranslationKey {
	switch (source) {
		case "web":
			return "users.source_type.web";
		case "mobile":
			return "users.source_type.mobile";
		case "terminal":
			return "users.source_type.terminal";
		case "system":
			return "users.source_type.system";
		default:
			return "general.unknown";
	}
}
